/**
 * @module cc
 */
/**
 * Class for BitmapFont handling.
 * @class BitmapFont
 * @extends RawAsset
 * @constructor
 */
var BitmapFont = cc.Class({
    name: 'cc.BitmapFont',
    extends: cc.Font
});

cc.BitmapFont = BitmapFont;
module.exports = BitmapFont;
